import { type ReactNode } from "react";

type TwoPaneLayoutProps = {
  isSidebarOpen: boolean;
  onCloseSidebar: () => void;
  sidebar: ReactNode;
  main: ReactNode;
  sidebarClassName?: string;
  mainClassName?: string;
};

const TwoPaneLayout = ({
  isSidebarOpen,
  onCloseSidebar,
  sidebar,
  main,
  sidebarClassName = "",
  mainClassName = "",
}: TwoPaneLayoutProps) => {
  return (
    <div className="flex flex-1 overflow-hidden min-h-0 min-w-0">
      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/40 backdrop-blur-[1px] md:hidden"
          onClick={onCloseSidebar}
        />
      )}

      <div
        className={
          `fixed inset-y-0 left-0 z-40 w-80 transform transition-transform duration-300 ` +
          `bg-card border-r border-border ` +
          `${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} ` +
          `md:static md:translate-x-0 md:transform-none ${sidebarClassName}`
        }
      >
        <div className="h-full min-h-0 flex flex-col">{sidebar}</div>
      </div>

      <main className={`flex-1 flex flex-col overflow-hidden min-h-0 min-w-0 ${mainClassName}`}>
        {main}
      </main>
    </div>
  );
};

export default TwoPaneLayout;
